/** Particules ignorées en tête du nom de famille (DE BÉRARD => BÉRARD). LE / LA n'en sont pas : souvent le nom lui-même (LE GOFF) */
const PARTICLE = /^(?:de\s+la|de\s+l'|de|du|des|d')(?:\s+|(?<=')\s*)/i;

const letters = (value: string) =>
  value
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z]/gi, '')
    .toUpperCase();

/**
 * Initiales d'une personne, pour les pastilles : première lettre du prénom, puis première lettre du nom sans sa
 * particule. Jérémy CRUZ => JC, Jean-Olivier DE BÉRARD => JB.
 */
export function initials(firstName: string, lastName: string): string {
  const name = lastName.trim();
  // Nom réduit à une particule (ex. « De ») : on le garde tel quel
  const withoutParticle = name.replace(PARTICLE, '') || name;

  return letters(firstName).charAt(0) + letters(withoutParticle).charAt(0) || '?';
}
